import defaultTournamentLogo from "./../assets/images/defaultTournamentLogo.png";
import teamDefault from "./../assets/images/teamDefault.png";

export const generateRandomString = (length) => {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getTeamProfilePic = (imageUrl) => {
  if (!imageUrl || imageUrl === "String") {
    return teamDefault;
  } else {
    return imageUrl;
  }
};

export const trimTrailingZeroes = (number) => {
  if (number) {
    let str = number.toString();
    if (str.indexOf(".") !== -1) {
      str = str.replace(/\.?0*$/, "");
    }

    return str;
  }
};

// export const getPlayerProfilePic = (imageUrl) => {
//   if (!imageUrl || imageUrl === "String") {
//     return require("../assets/images/defaultProfile.png");
//   } else {
//     return { uri: imageUrl };
//   }
// };

export const getTournamentProfilePic = (imageUrl) => {
  if (!imageUrl || imageUrl == "String") {
    return defaultTournamentLogo;
  } else {
    return imageUrl;
  }
};

export const getTournamentBanberPic = (imageUrl) => {
  if (!imageUrl || imageUrl == "String") {
    return require("../assets/images/defaultBannerImage.png");
  } else {
    return imageUrl;
  }
};

// export const trimTrailingZeroes = (number) => {
//   let str = number.toString();
//   if (str.indexOf(".") !== -1) {
//     str = str.replace(/\.?0*$/, "");
//   }

//   return str;
// };

// export const getStatDisplayValue = (value) => {
//   if (!value) return 0;
//   if (typeof value === "string") return value;
//   const parsedValue = trimTrailingZeroes(parseFloat(value).toFixed(2));

//   if (isNaN(parsedValue)) {
//     return 0;
//   } else {
//     return parsedValue;
//   }
// };

// export const getDisplayNameFromContact = (contact) => {
//   console.log("Contact => ", contact);

//   if (contact?.displayName) {
//     return contact?.displayName;
//   }

//   return `${contact?.givenName} ${contact?.familyName}`;
// };

export const maskStringAtStart = (
  str,
  lengthOfTheVisiblePart,
  padSymbolToBeAdded
) => {
  const visiblePart = str?.slice(lengthOfTheVisiblePart);
  const maskedString = visiblePart?.padStart(str?.length, padSymbolToBeAdded); // 1st - Total Resultant length, 2nd - Symbol to be added
  return maskedString;
};

export const maskStringAtEnd = (
  str,
  lengthOfTheVisiblePart,
  padSymbolToBeAdded
) => {
  const visiblePart = str?.slice(0, lengthOfTheVisiblePart);
  const maskedString = visiblePart?.padEnd(str?.length, padSymbolToBeAdded); // 1st - Total Resultant length, 2nd - Symbol to be added
  return maskedString;
};

function parseTimestamp(ts) {
  if (ts === undefined || ts === null || ts === "") return null;

  // If it's a Date string (not numeric), parse directly.
  if (typeof ts === "string" && isNaN(Number(ts))) {
    const d = new Date(ts);
    return isNaN(d.getTime()) ? null : d;
  }

  const n = Number(ts);
  if (isNaN(n)) return null;

  // Detect seconds vs milliseconds using realistic ranges:
  //
  // Timestamps in seconds for dates up to year 2100 are <= 4.1e9 (< 1e10).
  // Any timestamp >= 1e10 (10 billion) must be in milliseconds (1e10 seconds is year 2286).
  // E.g., birth dates in the 1970s like 97871400000 (~Feb 1973) are in milliseconds.
  const isMilliseconds = Math.abs(n) >= 1e10;

  let date = isMilliseconds ? new Date(n) : new Date(n * 1000);

  // Sanity check: if the result gives an unrealistic year (e.g. > 2200), try the alternative unit
  const year = date.getFullYear();
  if (year > 2200) {
    const altDate = new Date(n);
    if (
      !isNaN(altDate.getTime()) &&
      altDate.getFullYear() >= 1900 &&
      altDate.getFullYear() <= 2100
    ) {
      date = altDate;
    }
  } else if (year < 1920 && n > 0) {
    const altDate = new Date(n * 1000);
    if (
      !isNaN(altDate.getTime()) &&
      altDate.getFullYear() >= 1900 &&
      altDate.getFullYear() <= 2100
    ) {
      date = altDate;
    }
  }

  return isNaN(date.getTime()) ? null : date;
}

export function getAgeFromTimestamp(ts) {
  const dob = parseTimestamp(ts);
  if (!dob) return "N/A";

  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();

  // If birthday hasn't occurred yet this year, subtract 1.
  const monthDiff = now.getMonth() - dob.getMonth();
  const dayDiff = now.getDate() - dob.getDate();
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return `${age} Yrs`;
}

export function getDobFromTimestamp(ts) {
  const dob = parseTimestamp(ts);
  if (!dob) return "N/A";

  const day = String(dob.getDate()).padStart(2, "0");
  const month = String(dob.getMonth() + 1).padStart(2, "0");
  const year = dob.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatTimestampToReadableDate(ts) {
  const date = parseTimestamp(ts);
  if (!date) return "N/A";

  const weekday = date.toLocaleString("en-GB", { weekday: "short" });
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}
